import { Permission } from './../types/permissions.type';
import * as constants from "../constants/constants";
import { User } from '../types/user.type';
import { ArticleInfomation } from '../types/ArticleInformation.type';
import { Units } from '../types/units.type';
import { OfferField } from '../types/offerField.type';

export interface AdminState {
    allUsers: User[],
    selectedUser: User,
    permissions: Permission[],
    responsibility: {},
    usersForResponsibilities: any[],
    articleInformation: ArticleInfomation,
    units: Units[],
    offerField: OfferField,
    offerConditions: string,
    auditLogs: any[],
    colorPalettes: any[],
    selectedMaterial: any,
    suppliers: any[]
    impressionQuestions: any,
    impressionQuestion: object,
    usersDashboardInformation: any,
    kubitSettings: any,
    kubitSyncResult: any,
    kubitSyncLog: any,
    kubitDiscovery: any,
    // Live-progress state for the sync stepper. `progress` is the latest
    // active-or-finished run for the current company (one object); `runs`
    // is the paginated history list; `runDetailCache` is keyed by run_uuid
    // so re-expanding a previously-viewed history row is instant.
    kubitSyncProgress: any,
    kubitSyncRuns: any,
    kubitSyncRunDetailCache: { [runUuid: string]: any },
    departmentsDetailed: any[],
    unitsDetailed: any[],
    suppliersDetailed: any[],
    materialsDetailed: any[]
}

const initialState = () => {
    return {
        allUsers: [],
        selectedUser: {} as User,
        permissions: [] as Permission[],
        responsibility: {},
        usersForResponsibilities: [],
        articleInformation: {} as ArticleInfomation,
        units: [] as Units[],
        offerField: {name: ''},
        offerConditions: '',
        auditLogs: [],
        colorPalettes: [],
        selectedMaterial: {},
        suppliers: [],
        impressionQuestions: [],
        impressionQuestion: null,
        usersDashboardInformation: [],
        kubitSettings: null,
        kubitSyncResult: null,
        kubitSyncLog: { data: [], meta: null },
        kubitDiscovery: { countryIds: [], entityTypeIds: [], phonePrefixIds: [] },
        kubitSyncProgress: { run: null, steps: [] },
        kubitSyncRuns: { data: [], meta: null },
        kubitSyncRunDetailCache: {},
        departmentsDetailed: [],
        unitsDetailed: [],
        suppliersDetailed: [],
        materialsDetailed: []
    }
}

const admin = (state: AdminState = initialState(), action: any) => {
    switch (action.type) {
        case constants.FETCH_USERS: {
            return { 
                ...state, 
                allUsers: action.payload
            };
        }
        case constants.FETCH_USERS_DASHBOARD_INFORMATION: {
            return {
                ...state,
                usersDashboardInformation: action.payload
            };
        }
        case constants.FETCH_USER: {
            return { 
                ...state, 
                selectedUser: action.payload
            };
        }
        case constants.FETCH_PERMISSIONS: {
            return { 
                ...state, 
                permissions: action.payload
            };
        }
        case constants.FETCH_MATERIALS: {
            return { 
                ...state, 
                materials: action.payload
            };
        }
        case constants.FETCH_RESPONSIBILITY: {
            return { 
                ...state, 
                responsibility: action.payload
            };
        }
        case constants.FETCH_USERS_FOR_RESPONSIBILITIES: {
            return {
                ...state,
                usersForResponsibilities: action.payload.data.data
            };
        }
        case constants.GET_DEPARTMENTS_DETAILED: {
            return {
                ...state,
                departmentsDetailed: action.payload
            };
        }
        case constants.GET_UNITS_DETAILED: {
            return {
                ...state,
                unitsDetailed: action.payload
            };
        }
        case constants.GET_SUPPLIERS_DETAILED: {
            return {
                ...state,
                suppliersDetailed: action.payload
            };
        }
        case constants.GET_MATERIALS_DETAILED: {
            return {
                ...state,
                materialsDetailed: action.payload
            };
        }
        case(constants.FETCH_ARTICLE_TYPE): {
            return {
                ...state,
                articleType: action.payload
            }
        }
        case(constants.FETCH_ARTICLE): {
            return {
                ...state,
                articleInformation: action.payload
            }
        }
        case(constants.RESET_ARTICLE): {
            return {
                ...state,
                articleInformation: {}
            }
        }
        case(constants.CREATE_UNIT): {
            return {
                ...state,
                units: action.payload
            }
        }
        case(constants.EDIT_UNIT): {
            return {
                ...state,
                units: action.payload
            }
        }
        case(constants.DELETE_UNIT): {
            return {
                ...state,
                units: action.payload
            }
        }
        case(constants.GET_OFFER_FIELD): {
            return {
                ...state,
                offerField: action.payload
            }
        }
        case(constants.CLEAR_OFFER_FIELD): {
            return {
                ...state,
                offerField: {name: ''}
            }
        }
        case(constants.GET_OFFER_CONDITIONS): {
            return {
                ...state,
                offerConditions: action.payload[0]
            }
        }
        case(constants.GET_AUDIT_LOGS): {
            return {
                ...state,
                auditLogs: action.payload
            }
        }
        case(constants.GET_COLOR_PALETTES): {
            return {
                ...state,
                colorPalettes: action.payload
            }
        }
        case(constants.GET_MATERIAL): {
            return {
                ...state,
                selectedMaterial: action.payload.data
            }
        }
        case(constants.GET_SUPPLIERS): {
            return {
                ...state,
                suppliers: action.payload
            }
        }
        case(constants.GET_IMPRESSION_QUESTIONS): {
            return {
                ...state,
                impressionQuestions: action.payload
            }
        }
        case(constants.GET_IMPRESSION_QUESTION): {
            return {
                ...state,
                impressionQuestion: action.payload
            }
        }
        case(constants.GET_KUBIT_SETTINGS):
        case(constants.SAVE_KUBIT_SETTINGS):
        case(constants.DISCONNECT_KUBIT):
        case(constants.RESET_KUBIT_CURSOR): {
            return {
                ...state,
                kubitSettings: action.payload
            }
        }
        case(constants.TRIGGER_KUBIT_SYNC): {
            return {
                ...state,
                kubitSyncResult: action.payload
            }
        }
        case(constants.GET_KUBIT_SYNC_LOG): {
            return {
                ...state,
                kubitSyncLog: action.payload
            }
        }
        case(constants.GET_KUBIT_DISCOVERY): {
            return {
                ...state,
                kubitDiscovery: action.payload
            }
        }
        case(constants.GET_KUBIT_SYNC_PROGRESS): {
            // Polling action — only update when the action carried a real
            // payload (action creator returns null on transient network
            // errors so we don't wipe the last known good state).
            if (!action.payload) {
                return state;
            }
            return {
                ...state,
                kubitSyncProgress: action.payload
            }
        }
        case(constants.GET_KUBIT_SYNC_RUNS): {
            return {
                ...state,
                kubitSyncRuns: action.payload
            }
        }
        case(constants.GET_KUBIT_SYNC_RUN_DETAIL): {
            // Cache by uuid so a re-expand renders instantly without
            // re-fetching. The action creator includes runUuid in the
            // payload alongside { run, steps }.
            const { runUuid, ...detail } = action.payload || {};
            if (!runUuid) {
                return state;
            }
            return {
                ...state,
                kubitSyncRunDetailCache: {
                    ...state.kubitSyncRunDetailCache,
                    [runUuid]: detail
                }
            }
        }
    }
    return state;
}

export default admin;